import styled from "styled-components"
import { AppBar, IconButton, Typography } from "@mui/material"
import CustomButton from "../custom-button/custom-button.component"
import * as Logo from "../../assets/icons/A_horz_logo.svg"
import { Box } from "@mui/system"

export const Section = styled.div``

export const CustomAppBar = styled(AppBar)`
  padding-bottom: 1rem;
  background-color: ${props =>
    props.bgColor
      ? ({ theme }) => theme.palette.primary.main
      : ({ theme }) => theme.palette.primary.light};
`
export const MainNav = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease !important;
  ${({ resize }) => (resize ? `padding-top: 1em;` : `padding-top: 2.5em;`)};
  ${({ theme }) => theme.breakpoints.down("md")} {
    padding-top: 1em;
  }
`

// export const Item = styled(CustomLink)`
//   font-weight: 500;
//   padding: 1em;
//   color: ${props =>
//     props.color
//       ? ({ theme }) => theme.palette.secondary.main
//       : ({ theme }) => theme.palette.primary.main};
//   transition: all 0.3s ease-in-out;
//   &:hover {
//     //background-color: green;
//     border-bottom: 2px solid green;
//   }
// `

export const Button = styled(CustomButton)`
  background-color: rgba(164, 157, 188, 0.2) !important;
  margin-left: 1rem;
  color: ${props =>
    props.textColor
      ? ({ theme }) => theme.palette.secondary.main
      : ({ theme }) => theme.palette.primary.main};

  &:hover {
    background-color: ${props =>
      props.blackHeader
        ? ({ theme }) => theme.palette.secondary.main
        : ({ theme }) => theme.palette.primary.main} !important;
    color: ${props =>
      props.blackHeader
        ? ({ theme }) => theme.palette.primary.main
        : ({ theme }) => theme.palette.secondary.main};
  }
`
export const AftershockLogo = styled(Logo)`
  max-width: 145px;
  width: 100%;
  .cls-1 {
    fill: ${props =>
      props.color
        ? ({ theme }) => theme.palette.primary.light
        : ({ theme }) => theme.palette.primary.main};
  }
`

export const MenuButton = styled(IconButton)`
  padding-right: 0;
  padding-left: 0;
`
export const Item = styled.div`
  padding: 1em;
  a {
    &.active {
      &:after {
        width: 100%;
      }
    }
  }

  a {
    font-weight: 500;
    color: ${props =>
      props.color
        ? ({ theme }) => theme.palette.secondary.main
        : ({ theme }) => theme.palette.primary.main};
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;

    &:after {
      transition: all 0.3s ease;
      content: "";
      position: absolute;
      height: 1px;
      background-color: ${props =>
        props.color
          ? ({ theme }) => theme.palette.secondary.main
          : ({ theme }) => theme.palette.primary.main};
      bottom: -4px;
      width: 0;
      left: 0;
    }
  }
  &:hover:not(.logo) {
    a {
      &:after {
        width: 100%;
      }
    }
  }

  &.es p {
    font-weight: 500;
    color: ${props =>
      props.color
        ? ({ theme }) => theme.palette.secondary.main
        : ({ theme }) => theme.palette.primary.main};
    text-transform: uppercase;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;

    &:after {
      transition: all 0.3s ease;
      content: "";
      position: absolute;
      height: 1px;
      background-color: ${props =>
        props.color
          ? ({ theme }) => theme.palette.secondary.main
          : ({ theme }) => theme.palette.primary.main};
      bottom: -4px;
      width: 0;
      left: 0;
    }
  }
  &.es p {
    line-height: 16px;
    cursor: default;
    &:after {
      width: 100%;
    }
  }

  &.en {
    margin-left: 4rem;
  }
`
export const ItemsContainer = styled(Box)`
  display: flex;
  align-items: center;
`
export const Description = styled(Typography)``
